import { Provider } from "@angular/core";
import { providedAttachments } from "@tylertech/attachments-module";
import { NotificationActionInjector } from "@tylertech/core-module";
import { provideDataLoad } from "@tylertech/data-load-module";
import * as services from "./services";

export function provideMetadata(): Array<Provider>
{
    return [
        // ! NOTE: DO NOT INCLUDE ANIMATIONS HERE! I KNOW IgxGrid REQUIRES IT. BUT THIS HAS TO BE LOADED AT THE APP LEVEL
        // provideAnimations(),
        // provideAnimationsAsync(),
        providedAttachments(),
        provideDataLoad(),
        services.CachedCodeLookupService,
        services.CellEditService,
        services.CodeLookupService,
        services.GridActionService,
        services.GridCellStateService,
        services.GridDeleteService,
        services.GridEntityService,
        services.GridExportService,
        services.GridEventService,
        services.GridFilterService,
        services.GridFormatService,
        services.GridLayoutService,
        services.GridLoadService,
        services.GridLookupService,
        services.GridMetadataService,
        services.GridProcessingService,
        services.GridSelectionService,
        services.GridSortService,
        services.GridSummaryService,
        services.GridValidationService,
        services.InfoGridLayoutService,
        services.MetadataActionService,
        services.MetadataDialogService,
        services.MetadataErrorService,
        services.MetadataFormService,
        services.MetadataIframeService,
        services.MetadataInputFormatterService,
        services.MetadataInputSelectService,
        services.MetadataInputTypeHelperService,
        services.MetadataLoadViewService,
        services.MetadataPropertyService,
        services.MetadataService,
        services.MetadataValidationService,
        services.MetadataViewService,
        services.MultipleEntityEditService,
        services.ViewShortcutService,
        { provide: NotificationActionInjector, useClass: services.MetadataActionService }
    ];
}
